import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { AiAgentGroupService } from 'src/app/_services/ai-agent-group.service';
import { Global } from 'src/app/_services/global.service';
import { ModalService } from 'src/app/_services/modal.service';
import { BaseComponent } from 'src/app/ui-library/component/base.component';
import { AIAgentGroupTemplate } from './ai-agent-group-item.constant';
import { MmitaAssetService } from 'src/app/_services/mmitaAsset.service';

@Component({
  selector: 'app-ai-agent-group',
  templateUrl: './ai-agent-group.component.html',
})
export class AiAgentGroupComponent extends BaseComponent implements OnInit {
  data: Array<any>;
  aiBuddyAssets: Array<any>;
  columnDefs = [];
  formGroup: FormGroup
  constructor(
    private aiAgentGroupService: AiAgentGroupService,
    public global: Global,
    private modalService: ModalService,
    private toastr: ToastrService,
    private assetService: MmitaAssetService
  ) {
    super(global);
  }

  multiRowValHtml(params) {
    let innerHtml = ''
    if (params?.value.length <= 0) {
      return innerHtml
    }

    params?.value.forEach(item => {
      innerHtml += `<li style="list-style: none;">${item}</li>`
    })
    return `<ul style="padding-inline-start: unset;">${innerHtml}<ul>`

  }

  setColumnDefs() {
    this.columnDefs = [
      { headerName: 'ID', field: 'id' },
      { headerName: 'Name', field: 'name' },
      {
        headerName: 'Agent Kinds', field: 'agentKinds',
        cellRenderer: params => { return this.multiRowValHtml(params) }
      },
      { headerName: 'Max Minutes', field: 'maxMinutes' },

      {
        headerName: 'Action',
        pinned: 'right',
        cellRenderer: params => {
          return ` 
                      <i class="fas fa-fw fa-bars" id="moreDetail" style="margin-right:3px; cursor: pointer;"></i>
                      <i class="fas fa-fw fa-edit text-primary" id="editDetail" style="margin-right:3px; cursor: pointer;"></i>
                      <i class="fas fa-fw fa-trash grid-btn-icon text-danger" id="delete" style="margin-right:3px; cursor: pointer;"></i>`;
        },
        onCellClicked: params => {
          switch (params.event.target.id) {
            case 'editDetail':
              this.showItem(params?.data)
              break;
            case 'delete':
              this.modalService.createNzDeleteModal(() => this.delete.call(this, params?.data?.id))
              break;
            case 'moreDetail':
              this.modalService.showDetail(params.data, 'AI Agent Group Detail')
              break;
          }
        },
        minWidth: 120
      }
    ];
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    this.getAll();
  }

  ngOnInit() {
    this.setColumnDefs();
    this.getAIBuddyAssets()
  }

  getAIBuddyAssets() {
    this.assetService.getAll({ BusinessType: 'AiBuddy', PageSize: -1 }).subscribe(res => {
      this.aiBuddyAssets = res.data
    })
  }

  getAll() {
    this.aiAgentGroupService.getAll().subscribe(res => {
      this.data = res.data;
    })
  }

  delete(id) {
    this.aiAgentGroupService.delete(id)
      .subscribe(data => {
        this.getAll();
        this.toastr.success('Data Deleted Successfully...!', 'Success');
      });
  }

  showItem(data?) {
    this.genFG(data)
    const dialogTemplate = AIAgentGroupTemplate(!!data, this.aiBuddyAssets)
    this.modalService.createNzModal(() => this.onSubmit.call(this, data?.id), this.formGroup, dialogTemplate)
  }


  onSubmit(itemId?) {
    return new Observable(subscriber => {
      const saveSuccess = () => {
        this.getAll()
        this.toastr.success('Data Saved Successfully...!', 'Success');
        subscriber.next()
        subscriber.complete()
      }
      itemId ? this.aiAgentGroupService.edit(itemId, this.formGroup.value).subscribe({
        next: x => saveSuccess(),
        error: x => subscriber.error(x)
      }) : this.aiAgentGroupService.create(this.formGroup.value).subscribe({
        next: x => saveSuccess(),
        error: x => subscriber.error(x)
      })
    })
  }

  genFG(res?) {
    this.formGroup = new FormGroup({
      name: new FormControl(res?.name, Validators.required),
      agentKinds: new FormControl(res?.agentKinds || [], Validators.required),
      maxMinutes: new FormControl(res?.maxMinutes, [Validators.required, this.rangeValidator(0, 10000)])
    });
  }

    private rangeValidator(min: number, max: number): ValidatorFn {
      return (control: any): ValidationErrors | null => {
        const value = control.value;
        if (value < min || value > max) {
          return {
            range: {
              message: `Value must be between ${min} and ${max}`,
              min,
              max,
              actual: value
            }
          };
        }
      };
    }
}

